import * as React from 'react'

import { ConnectedRadioButtons } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

const TitleField: React.FC = () => {
  const { getLabel } = useIntl()

  return (
    <label className="form-control">
      {getLabel('checkout.contact.honorific.title')}
      <ConnectedRadioButtons
        scope="salutation"
        alignment="horizontal"
        initialValue={getLabel('checkout.contact.honorific.mr')}
        items={[
          {
            label: getLabel('checkout.contact.honorific.mr'),
            value: getLabel('checkout.contact.honorific.mr'),
          },
          {
            label: getLabel('checkout.contact.honorific.mrs'),
            value: getLabel('checkout.contact.honorific.mrs'),
          },
        ]}
      />
    </label>
  )
}

export default TitleField
